"use strict";

var _regeneratorRuntime = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var cov_17690pqyws = function () {
  var path = "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/file/helpers.js";
  var hash = "78c753a6d8f9156d2aba2cab3b6300535943aba5";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/file/helpers.js",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 26
        },
        end: {
          line: 22,
          column: 1
        }
      },
      "1": {
        start: {
          line: 8,
          column: 16
        },
        end: {
          line: 8,
          column: 22
        }
      },
      "2": {
        start: {
          line: 9,
          column: 2
        },
        end: {
          line: 9,
          column: 54
        }
      },
      "3": {
        start: {
          line: 9,
          column: 22
        },
        end: {
          line: 9,
          column: 54
        }
      },
      "4": {
        start: {
          line: 10,
          column: 38
        },
        end: {
          line: 10,
          column: 48
        }
      },
      "5": {
        start: {
          line: 12,
          column: 2
        },
        end: {
          line: 17,
          column: 3
        }
      },
      "6": {
        start: {
          line: 13,
          column: 21
        },
        end: {
          line: 13,
          column: 92
        }
      },
      "7": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 16,
          column: 6
        }
      },
      "8": {
        start: {
          line: 18,
          column: 15
        },
        end: {
          line: 20,
          column: 3
        }
      },
      "9": {
        start: {
          line: 21,
          column: 2
        },
        end: {
          line: 21,
          column: 14
        }
      },
      "10": {
        start: {
          line: 24,
          column: 26
        },
        end: {
          line: 40,
          column: 1
        }
      },
      "11": {
        start: {
          line: 27,
          column: 21
        },
        end: {
          line: 27,
          column: 35
        }
      },
      "12": {
        start: {
          line: 28,
          column: 38
        },
        end: {
          line: 28,
          column: 48
        }
      },
      "13": {
        start: {
          line: 29,
          column: 23
        },
        end: {
          line: 29,
          column: 27
        }
      },
      "14": {
        start: {
          line: 30,
          column: 19
        },
        end: {
          line: 30,
          column: 90
        }
      },
      "15": {
        start: {
          line: 31,
          column: 19
        },
        end: {
          line: 31,
          column: 89
        }
      },
      "16": {
        start: {
          line: 32,
          column: 18
        },
        end: {
          line: 38,
          column: 4
        }
      },
      "17": {
        start: {
          line: 39,
          column: 2
        },
        end: {
          line: 39,
          column: 17
        }
      },
      "18": {
        start: {
          line: 42,
          column: 34
        },
        end: {
          line: 56,
          column: 1
        }
      },
      "19": {
        start: {
          line: 43,
          column: 53
        },
        end: {
          line: 43,
          column: 57
        }
      },
      "20": {
        start: {
          line: 45,
          column: 2
        },
        end: {
          line: 54,
          column: 3
        }
      },
      "21": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 43
        }
      },
      "22": {
        start: {
          line: 47,
          column: 9
        },
        end: {
          line: 54,
          column: 3
        }
      },
      "23": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 48,
          column: 61
        }
      },
      "24": {
        start: {
          line: 49,
          column: 9
        },
        end: {
          line: 54,
          column: 3
        }
      },
      "25": {
        start: {
          line: 50,
          column: 23
        },
        end: {
          line: 50,
          column: 63
        }
      },
      "26": {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 53,
          column: 5
        }
      },
      "27": {
        start: {
          line: 52,
          column: 6
        },
        end: {
          line: 52,
          column: 56
        }
      },
      "28": {
        start: {
          line: 55,
          column: 2
        },
        end: {
          line: 55,
          column: 18
        }
      },
      "29": {
        start: {
          line: 58,
          column: 23
        },
        end: {
          line: 67,
          column: 2
        }
      },
      "30": {
        start: {
          line: 58,
          column: 90
        },
        end: {
          line: 67,
          column: 1
        }
      },
      "31": {
        start: {
          line: 69,
          column: 27
        },
        end: {
          line: 81,
          column: 1
        }
      },
      "32": {
        start: {
          line: 70,
          column: 21
        },
        end: {
          line: 70,
          column: 35
        }
      },
      "33": {
        start: {
          line: 71,
          column: 38
        },
        end: {
          line: 71,
          column: 48
        }
      },
      "34": {
        start: {
          line: 72,
          column: 19
        },
        end: {
          line: 72,
          column: 23
        }
      },
      "35": {
        start: {
          line: 73,
          column: 19
        },
        end: {
          line: 79,
          column: 4
        }
      },
      "36": {
        start: {
          line: 80,
          column: 2
        },
        end: {
          line: 80,
          column: 18
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 5,
            column: 26
          },
          end: {
            line: 5,
            column: 27
          }
        },
        loc: {
          start: {
            line: 7,
            column: 6
          },
          end: {
            line: 22,
            column: 1
          }
        },
        line: 7
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 24,
            column: 26
          },
          end: {
            line: 24,
            column: 27
          }
        },
        loc: {
          start: {
            line: 26,
            column: 5
          },
          end: {
            line: 40,
            column: 1
          }
        },
        line: 26
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 42,
            column: 34
          },
          end: {
            line: 42,
            column: 35
          }
        },
        loc: {
          start: {
            line: 42,
            column: 50
          },
          end: {
            line: 56,
            column: 1
          }
        },
        line: 42
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 58,
            column: 23
          },
          end: {
            line: 58,
            column: 24
          }
        },
        loc: {
          start: {
            line: 58,
            column: 90
          },
          end: {
            line: 67,
            column: 1
          }
        },
        line: 58
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 69,
            column: 27
          },
          end: {
            line: 69,
            column: 28
          }
        },
        loc: {
          start: {
            line: 69,
            column: 99
          },
          end: {
            line: 81,
            column: 1
          }
        },
        line: 69
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 9,
            column: 54
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 9,
            column: 54
          }
        }, {
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 9,
            column: 54
          }
        }],
        line: 9
      },
      "1": {
        loc: {
          start: {
            line: 12,
            column: 2
          },
          end: {
            line: 17,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 12,
            column: 2
          },
          end: {
            line: 17,
            column: 3
          }
        }, {
          start: {
            line: 12,
            column: 2
          },
          end: {
            line: 17,
            column: 3
          }
        }],
        line: 12
      },
      "2": {
        loc: {
          start: {
            line: 13,
            column: 21
          },
          end: {
            line: 13,
            column: 92
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 13,
            column: 21
          },
          end: {
            line: 13,
            column: 28
          }
        }, {
          start: {
            line: 13,
            column: 32
          },
          end: {
            line: 13,
            column: 92
          }
        }],
        line: 13
      },
      "3": {
        loc: {
          start: {
            line: 30,
            column: 19
          },
          end: {
            line: 30,
            column: 90
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 30,
            column: 19
          },
          end: {
            line: 30,
            column: 26
          }
        }, {
          start: {
            line: 30,
            column: 30
          },
          end: {
            line: 30,
            column: 90
          }
        }],
        line: 30
      },
      "4": {
        loc: {
          start: {
            line: 45,
            column: 2
          },
          end: {
            line: 54,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 45,
            column: 2
          },
          end: {
            line: 54,
            column: 3
          }
        }, {
          start: {
            line: 45,
            column: 2
          },
          end: {
            line: 54,
            column: 3
          }
        }],
        line: 45
      },
      "5": {
        loc: {
          start: {
            line: 45,
            column: 6
          },
          end: {
            line: 45,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 45,
            column: 6
          },
          end: {
            line: 45,
            column: 13
          }
        }, {
          start: {
            line: 45,
            column: 17
          },
          end: {
            line: 45,
            column: 38
          }
        }],
        line: 45
      },
      "6": {
        loc: {
          start: {
            line: 47,
            column: 9
          },
          end: {
            line: 54,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 47,
            column: 9
          },
          end: {
            line: 54,
            column: 3
          }
        }, {
          start: {
            line: 47,
            column: 9
          },
          end: {
            line: 54,
            column: 3
          }
        }],
        line: 47
      },
      "7": {
        loc: {
          start: {
            line: 47,
            column: 13
          },
          end: {
            line: 47,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 47,
            column: 13
          },
          end: {
            line: 47,
            column: 21
          }
        }, {
          start: {
            line: 47,
            column: 25
          },
          end: {
            line: 47,
            column: 37
          }
        }],
        line: 47
      },
      "8": {
        loc: {
          start: {
            line: 49,
            column: 9
          },
          end: {
            line: 54,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 49,
            column: 9
          },
          end: {
            line: 54,
            column: 3
          }
        }, {
          start: {
            line: 49,
            column: 9
          },
          end: {
            line: 54,
            column: 3
          }
        }],
        line: 49
      },
      "9": {
        loc: {
          start: {
            line: 49,
            column: 13
          },
          end: {
            line: 49,
            column: 32
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 49,
            column: 13
          },
          end: {
            line: 49,
            column: 21
          }
        }, {
          start: {
            line: 49,
            column: 25
          },
          end: {
            line: 49,
            column: 32
          }
        }],
        line: 49
      },
      "10": {
        loc: {
          start: {
            line: 51,
            column: 4
          },
          end: {
            line: 53,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 51,
            column: 4
          },
          end: {
            line: 53,
            column: 5
          }
        }, {
          start: {
            line: 51,
            column: 4
          },
          end: {
            line: 53,
            column: 5
          }
        }],
        line: 51
      },
      "11": {
        loc: {
          start: {
            line: 51,
            column: 8
          },
          end: {
            line: 51,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 51,
            column: 8
          },
          end: {
            line: 51,
            column: 26
          }
        }, {
          start: {
            line: 51,
            column: 30
          },
          end: {
            line: 51,
            column: 62
          }
        }],
        line: 51
      },
      "12": {
        loc: {
          start: {
            line: 63,
            column: 37
          },
          end: {
            line: 63,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 63,
            column: 37
          },
          end: {
            line: 63,
            column: 44
          }
        }, {
          start: {
            line: 63,
            column: 48
          },
          end: {
            line: 63,
            column: 50
          }
        }],
        line: 63
      },
      "13": {
        loc: {
          start: {
            line: 64,
            column: 11
          },
          end: {
            line: 64,
            column: 80
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 64,
            column: 11
          },
          end: {
            line: 64,
            column: 18
          }
        }, {
          start: {
            line: 64,
            column: 22
          },
          end: {
            line: 64,
            column: 80
          }
        }],
        line: 64
      },
      "14": {
        loc: {
          start: {
            line: 65,
            column: 7
          },
          end: {
            line: 65,
            column: 31
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 65,
            column: 16
          },
          end: {
            line: 65,
            column: 24
          }
        }, {
          start: {
            line: 65,
            column: 27
          },
          end: {
            line: 65,
            column: 31
          }
        }],
        line: 65
      },
      "15": {
        loc: {
          start: {
            line: 66,
            column: 14
          },
          end: {
            line: 66,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 66,
            column: 14
          },
          end: {
            line: 66,
            column: 20
          }
        }, {
          start: {
            line: 66,
            column: 24
          },
          end: {
            line: 66,
            column: 49
          }
        }],
        line: 66
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "78c753a6d8f9156d2aba2cab3b6300535943aba5"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveContent = exports.payload = exports.getContentFromFile = exports.deleteFile = exports.ensureFile = void 0;

var _base = _interopRequireDefault(require("base-64"));

var _utf = _interopRequireDefault(require("utf8"));

var _core = require("../../core");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

cov_17690pqyws.s[0]++;

var ensureFile = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var filepath, defaultContent, message, authentication, repository, config, branch, _config, _ref3, username, name, _payload, _message, file;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            filepath = _ref.filepath, defaultContent = _ref.defaultContent, message = _ref.message, authentication = _ref.authentication, repository = _ref.repository, config = _ref.config, branch = _ref.branch;
            cov_17690pqyws.f[0]++;
            _config = (cov_17690pqyws.s[1]++, config);
            cov_17690pqyws.s[2]++;

            if (authentication) {
              cov_17690pqyws.b[0][0]++;
              cov_17690pqyws.s[3]++;
              _config = authentication.config;
            } else {
              cov_17690pqyws.b[0][1]++;
            }

            _ref3 = (cov_17690pqyws.s[4]++, repository), username = _ref3.owner.username, name = _ref3.name;
            cov_17690pqyws.s[5]++;

            if (authentication) {
              cov_17690pqyws.b[1][0]++;
              _message = (cov_17690pqyws.s[6]++, (cov_17690pqyws.b[2][0]++, message) || (cov_17690pqyws.b[2][1]++, "Created '".concat(filepath, "' using '").concat(authentication.token.name, "'")));
              cov_17690pqyws.s[7]++;
              _payload = payload({
                content: defaultContent,
                message: _message,
                authentication: authentication,
                repository: repository,
                branch: branch
              });
            } else {
              cov_17690pqyws.b[1][1]++;
            }

            cov_17690pqyws.s[8]++;
            _context.next = 11;
            return (0, _core.ensureFile)({
              owner: username,
              repo: name,
              filepath: filepath,
              payload: _payload,
              config: _config
            });

          case 11:
            file = _context.sent;
            cov_17690pqyws.s[9]++;
            return _context.abrupt("return", file);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function ensureFile(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.ensureFile = ensureFile;
cov_17690pqyws.s[10]++;

var deleteFile = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref4) {
    var file, message, authentication, repository, branch, _ref6, config, _ref7, username, name, _ref8, filepath, _message, _payload, deleted;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            file = _ref4.file, message = _ref4.message, authentication = _ref4.authentication, repository = _ref4.repository, branch = _ref4.branch;
            cov_17690pqyws.f[1]++;
            _ref6 = (cov_17690pqyws.s[11]++, authentication), config = _ref6.config;
            _ref7 = (cov_17690pqyws.s[12]++, repository), username = _ref7.owner.username, name = _ref7.name;
            _ref8 = (cov_17690pqyws.s[13]++, file), filepath = _ref8.filepath;
            _message = (cov_17690pqyws.s[14]++, (cov_17690pqyws.b[3][0]++, message) || (cov_17690pqyws.b[3][1]++, "Deleted '".concat(filepath, "' using '").concat(authentication.token.name, "'")));
            _payload = (cov_17690pqyws.s[15]++, payload({
              message: _message,
              authentication: authentication,
              repository: repository,
              file: file,
              branch: branch
            }));
            cov_17690pqyws.s[16]++;
            _context2.next = 10;
            return (0, _core.removeFile)({
              owner: username,
              repo: name,
              filepath: filepath,
              payload: _payload,
              config: config
            });

          case 10:
            deleted = _context2.sent;
            cov_17690pqyws.s[17]++;
            return _context2.abrupt("return", deleted);

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function deleteFile(_x2) {
    return _ref5.apply(this, arguments);
  };
}();

exports.deleteFile = deleteFile;
cov_17690pqyws.s[18]++;

var getContentFromFile = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(file) {
    var _ref10, content, encoding, download_url, git_url, _content, blobObject;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            cov_17690pqyws.f[2]++;
            _ref10 = (cov_17690pqyws.s[19]++, file), content = _ref10.content, encoding = _ref10.encoding, download_url = _ref10.download_url, git_url = _ref10.git_url;
            cov_17690pqyws.s[20]++;

            if (!((cov_17690pqyws.b[5][0]++, content) && (cov_17690pqyws.b[5][1]++, encoding === 'base64'))) {
              _context3.next = 9;
              break;
            }

            cov_17690pqyws.b[4][0]++;
            cov_17690pqyws.s[21]++;
            _content = (0, _core.decodeBase64ToUtf8)(content);
            _context3.next = 32;
            break;

          case 9:
            cov_17690pqyws.b[4][1]++;
            cov_17690pqyws.s[22]++;

            if (!((cov_17690pqyws.b[7][0]++, !content) && (cov_17690pqyws.b[7][1]++, download_url))) {
              _context3.next = 19;
              break;
            }

            cov_17690pqyws.b[6][0]++;
            cov_17690pqyws.s[23]++;
            _context3.next = 16;
            return (0, _core.get)({
              url: download_url,
              noCache: true
            });

          case 16:
            _content = _context3.sent;
            _context3.next = 32;
            break;

          case 19:
            cov_17690pqyws.b[6][1]++;
            cov_17690pqyws.s[24]++;

            if (!((cov_17690pqyws.b[9][0]++, !content) && (cov_17690pqyws.b[9][1]++, git_url))) {
              _context3.next = 31;
              break;
            }

            cov_17690pqyws.b[8][0]++;
            cov_17690pqyws.s[25]++;
            _context3.next = 26;
            return (0, _core.get)({
              url: git_url,
              noCache: true
            });

          case 26:
            blobObject = _context3.sent;
            cov_17690pqyws.s[26]++;

            if ((cov_17690pqyws.b[11][0]++, blobObject.content) && (cov_17690pqyws.b[11][1]++, blobObject.encoding === 'base64')) {
              cov_17690pqyws.b[10][0]++;
              cov_17690pqyws.s[27]++;
              _content = (0, _core.decodeBase64ToUtf8)(blobObject.content);
            } else {
              cov_17690pqyws.b[10][1]++;
            }

            _context3.next = 32;
            break;

          case 31:
            cov_17690pqyws.b[8][1]++;

          case 32:
            cov_17690pqyws.s[28]++;
            return _context3.abrupt("return", _content);

          case 34:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getContentFromFile(_x3) {
    return _ref9.apply(this, arguments);
  };
}();

exports.getContentFromFile = getContentFromFile;
cov_17690pqyws.s[29]++;

var payload = function payload(_ref11) {
  var content = _ref11.content,
      message = _ref11.message,
      authentication = _ref11.authentication,
      repository = _ref11.repository,
      file = _ref11.file,
      branch = _ref11.branch;
  cov_17690pqyws.f[3]++;
  cov_17690pqyws.s[30]++;
  return {
    author: {
      email: authentication.user.email,
      name: authentication.user.username
    },
    content: _base.default.encode(_utf.default.encode((cov_17690pqyws.b[12][0]++, content) || (cov_17690pqyws.b[12][1]++, ''))),
    message: (cov_17690pqyws.b[13][0]++, message) || (cov_17690pqyws.b[13][1]++, "Edit '".concat(file.path, "' using '").concat(authentication.token.name, "'")),
    sha: file ? (cov_17690pqyws.b[14][0]++, file.sha) : (cov_17690pqyws.b[14][1]++, null),
    new_branch: (cov_17690pqyws.b[15][0]++, branch) || (cov_17690pqyws.b[15][1]++, repository.default_branch)
  };
};

exports.payload = payload;
cov_17690pqyws.s[31]++;

var saveContent = /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref12) {
    var content, message, authentication, repository, file, branch, _ref14, config, _ref15, username, name, _ref16, path, response;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            content = _ref12.content, message = _ref12.message, authentication = _ref12.authentication, repository = _ref12.repository, file = _ref12.file, branch = _ref12.branch;
            cov_17690pqyws.f[4]++;
            _ref14 = (cov_17690pqyws.s[32]++, authentication), config = _ref14.config;
            _ref15 = (cov_17690pqyws.s[33]++, repository), username = _ref15.owner.username, name = _ref15.name;
            _ref16 = (cov_17690pqyws.s[34]++, file), path = _ref16.path;
            cov_17690pqyws.s[35]++;
            _context4.next = 8;
            return (0, _core.updateContent)({
              owner: username,
              repo: name,
              filepath: path,
              payload: payload({
                content: content,
                message: message,
                authentication: authentication,
                repository: repository,
                file: file,
                branch: branch
              }),
              config: config
            });

          case 8:
            response = _context4.sent;
            cov_17690pqyws.s[36]++;
            return _context4.abrupt("return", response);

          case 11:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function saveContent(_x4) {
    return _ref13.apply(this, arguments);
  };
}();

exports.saveContent = saveContent;